import * as React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Field, Text } from '@metrisk/react_metrisk-components'

import './RewardTrackingOptIn.scss'

interface RewardTrackingOptInProps {
  label: string
  value: string
  required?: boolean
  onChange: any
}

const RewardTrackingOptIn: React.FunctionComponent<RewardTrackingOptInProps> = (props) => {
  const intl = useIntl()

  return (
    <div className="reward-tracking-opt-in">
      <Field
        id="reward-tracking-opt-in"
        label={props.required ? props.label : undefined}
        value={props.value}
        type={props.required ? 'checkbox' : 'select'}
        options={!props.required ? [
          { label: intl.formatMessage({ defaultMessage: 'No' }), value: false },
          { label: intl.formatMessage({ defaultMessage: 'Yes' }), value: true },
        ] : undefined}
        onChange={props.onChange}
        required={props.required}
        fullWidth
      />
      <Text type={'P'} className="reward-tracking-opt-in__info">
      {props.required
        ? <FormattedMessage defaultMessage='By agreeing you confirm you are happy for us to share your contact details with either UPS, FedEx or DPD for the purpose of gift delivery and tracking only.'/>
        : <FormattedMessage defaultMessage='By selecting ‘Yes’ you confirm you are happy for us to share your contact details with DPD for the purpose of Gift delivery tracking only.'/>}
      </Text>
    </div>
  )
}

export default RewardTrackingOptIn
